













import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component
export default class Authorize extends Vue {
  private created(): void {
    const code = this.$route.query.code;
    const error = this.$route.query.error;
    if (error) {
      window.opener && window.opener.MESSENGER.emit('authorizeError', {});
      window.close();
      return;
    }
    window.opener && window.opener.MESSENGER.emit('authorize', {
      code: code as string,
    });
    window.close();
  }
}
